import React from 'react';
import $ from 'jquery';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class SyblFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sybl: null,

			needToUpdate: false,
			updateCount: 0,
      isDropdownOpen: false
		};
    this.selectRef = React.createRef();
	}

	static getDerivedStateFromProps(props, state) {
		let obj = {}
		if(state.date !== props.date || state.dateEnd !== props.dateEnd || state.group !== props.group || state.sybl !== props.sybl){
			obj = {...props, needToUpdate: true}
		}
		if(state.updateCount !== props.updateCount){
			obj.updateCount = props.updateCount
			obj.needToUpdate = true
		}
		return obj;
	}

	componentDidUpdate(props, state){
		let self = this
		if(this.state.needToUpdate && !this.state.isDropdownOpen){
			this.setState({needToUpdate: false}, function(){
				self.load()
			})
		}
	}

	componentDidMount() {
		this.load()
    $(this.selectRef.current).on('show.bs.select', () => {
      this.setState({ isDropdownOpen: true });
    });

    $(this.selectRef.current).on('hide.bs.select', () => {
      this.setState({ isDropdownOpen: false });
    });
	}

	setFilterValue = (e) => {
		let self = this
		let val = Array.from(e.target.selectedOptions, option => option.value);
		self.setState({sybl: val}, function(){
			self.state.refilter({
				selectedSybl: val
			})
		})
		
	}

	clearFilter = () => {
		this.state.refilter({
			selectedSybl: []
		})
	}

	load(){
		let self = this
		let url = "symbol_list?"
		if(self.state.view === 6){
			url = "symbol_list_agg?"
		}else if([4, 5, 7].includes(this.state.view)){
			url = "symbol_list_range?"
		}
		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+url+GetParams(self.state))
		.then(data => {
			$("#symbolFilter option").remove()
			data.forEach(function(item, index){
				$("#symbolFilter").append('<option>'+item.symbol+'</option>');
			})
			$("#symbolFilter").selectpicker('val', self.state.sybl).selectpicker('refresh');

			let selVal = $("#symbolFilter").selectpicker('val')
			if(selVal.length !== self.state.sybl.length){
				self.setState({sybl: selVal}, function(){
					self.state.refilter({
						selectedSybl: selVal
					})
				})
			}
		}).catch(e => console.log(e));
	}

	render(){
		return (
			<div className="col-lg-2 col-md-3 col-sm-4 pt-1 input-group">
				<select ref={this.selectRef} className="selectpicker form-control" id="symbolFilter" onChange={this.setFilterValue} title="Filter Symbols" data-live-search="true" data-actions-box="true" data-size="10" multiple></select>
				<div className="input-group-append">
					<button className="btn btn-outline-secondary clear-btn" type="button" onClick={this.clearFilter}><img src="icon.png" alt="X"/></button>
				</div>
			</div>
		)
	}
}
export default SyblFilter;